// Reads the canonical GET /api/transactions envelope: { data, totalCount }.
// totalCount is the number of matching records before pagination.
export function readTransactionQueryResponse(body) {
	const response = body || {};
	const rows = Array.isArray(response.data) ? response.data : [];
	const totalCount = Number.isInteger(response.totalCount) ? response.totalCount : 0;

	return { rows, totalCount };
}
